<div class="flex flex-col gap-4">
  <div>
    <span class="text-xs font-semibold text-gray-11 uppercase tracking-wider block">
      Titre de l'annonce
    </span>
    <span class="text-2xl text-gray-12 font-bold">{{ presentation()?.title || '-' }}</span>
  </div>
  <div>
    <span class="text-xs font-semibold text-gray-11 uppercase tracking-wider block">Description</span>
    <p class="text-gray-11 text-base leading-relaxed whitespace-pre-line">
      {{ presentation()?.description || '-' }}
    </p>
  </div>
</div>
